import { EnvironmentProviders, inject, makeEnvironmentProviders, provideAppInitializer } from '@angular/core';

import { FeatureFlagService } from './feature-flag.service';

export function provideFeatureFlags(): EnvironmentProviders {
    return makeEnvironmentProviders([
        provideAppInitializer(() => {
            inject(FeatureFlagService).start();
        }),
    ]);
}
